import { disconnect } from '@wagmi/core'
import { wagmiConfig } from 'lib/wagmiConfig'
import type { Connector } from 'wagmi'

export async function disconnectWallet(connector?: Connector | null): Promise<void> {
  await disconnect(wagmiConfig, connector ? { connector } : undefined)
}
